import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { DayAttribute, Event, GridCalendarLegendDataProvider } from '../../../model/grid-calendar';
import { GridCalendarUtils } from '../../../utils/grid-calendar-utils';

@Component( {
    selector: 'his-display-grid-calendar-legend',
    templateUrl: './his-display-grid-calendar-legend.component.html',
    styleUrls: ['./his-display-grid-calendar-legend.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayGridCalendarLegendComponent implements OnInit {
    readonly gridCalendarUtil = inject(GridCalendarUtils);

    @Input() public firstMonth: string = '';
    @Input() public lastMonth: string = '';
    @Input( { required: true } ) public gridCalendarLegendDataProvider!: GridCalendarLegendDataProvider;

    public showLegend: boolean = false;
    public legendEntries: ( Event | DayAttribute )[] = [];

    ngOnInit(): void {
        let firstMonth = this.gridCalendarUtil.createMonthByString( this.firstMonth );
        let lastMonth = this.gridCalendarUtil.createMonthByString( this.lastMonth );

        this.gridCalendarLegendDataProvider.getGridCalendarLegendData( firstMonth, lastMonth ).subscribe( legendEtries => {
            if ( legendEtries ) {
                this.legendEntries = legendEtries;
            }
        } );
    }
}
